import { createSlice } from '@reduxjs/toolkit';

import { parseResponse } from '@skynet/data-ws-core';
import { actionOnMessage } from '@skynet/data-ws-mm';

import type { JsonLoanOverviewSuccess, LoanOverviewState } from './types';
import { LoanOverviewCommands } from './types';

const allowedCommands = Object.values(LoanOverviewCommands);

export const initialState: LoanOverviewState = {
  overview: null,
  loanID: null,
  requestStatus: null,
  error: null,
};

const loanOverviewSlice = createSlice({
  name: 'loanOverview',
  initialState,
  reducers: {
    resetLoanOverview() {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(actionOnMessage, (state, action) => {
      const { json, skipProcessing, error } = parseResponse(action.payload, allowedCommands);

      if (skipProcessing || !json) return;

      const { command } = json;

      if (error) {
        state.error = error;
        state.requestStatus = 'error';
        return;
      }

      if (command === LoanOverviewCommands.LoanOverview) {
        const { overview, loanID } = json as JsonLoanOverviewSuccess;
        state.overview = overview;
        state.loanID = loanID;
        state.requestStatus = 'success';
        state.error = null;
      }
    });
  },
});

export const loanOverviewActions = { ...loanOverviewSlice.actions };

export default loanOverviewSlice.reducer;
